const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
document.querySelectorAll('[data-rail]').forEach(button => {
  button.addEventListener('click', () => {
    const rail = document.getElementById(button.dataset.rail);
    const item = rail.firstElementChild;
    const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap);
    rail.scrollBy({left: step * Number(button.dataset.direction), behavior: reducedMotion ? 'instant' : 'smooth'});
  });
});
document.querySelectorAll('.product-rail,.hero-rail').forEach(rail => {
  const update = () => {
    const controls = rail.parentElement.querySelector('.rail-controls');
    if (controls) {
      controls.hidden = rail.scrollWidth <= rail.clientWidth + 2;
      const image = rail.querySelector('.product-image');
      controls.style.setProperty('--control-top', `${image.offsetHeight / 2}px`);
    }
    document.querySelectorAll(`[data-rail="${rail.id}"]`).forEach(button => {
      button.disabled = button.dataset.direction === '-1' ? rail.scrollLeft < 2 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    });
  };
  rail.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update);
  update();
});
const menuButton = document.querySelector('.menu-toggle');
const menu = document.getElementById('mobile-menu');
menuButton.addEventListener('click', () => {
  const open = menuButton.getAttribute('aria-expanded') !== 'true';
  menuButton.setAttribute('aria-expanded', String(open));
  menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  menu.hidden = !open;
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && !menu.hidden) {
    menu.hidden = true;
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open menu');
    menuButton.focus();
  }
});

const desktopMenus = Array.from(document.querySelectorAll('.im-desktop-nav .im-nav-group'));
desktopMenus.forEach(dropdown => dropdown.addEventListener('toggle', () => {
  if (dropdown.open) desktopMenus.forEach(other => { if (other !== dropdown) other.open = false; });
}));
document.addEventListener('click', event => {
  desktopMenus.forEach(dropdown => { if (!dropdown.contains(event.target)) dropdown.open = false; });
  if (!menu.hidden && !menu.contains(event.target) && !menuButton.contains(event.target)) {
    menu.hidden = true;
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open menu');
  }
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  desktopMenus.forEach(dropdown => {
    if (dropdown.open) {
      dropdown.open = false;
      dropdown.querySelector('summary').focus();
    }
  });
});
const productMenu = document.querySelector('.im-mobile-products');
const updateProductMenuFade = () => {
  productMenu.classList.toggle('can-scroll-left', productMenu.scrollLeft > 2);
  productMenu.classList.toggle('can-scroll-right', productMenu.scrollLeft + productMenu.clientWidth < productMenu.scrollWidth - 2);
};
productMenu.addEventListener('scroll', updateProductMenuFade, {passive:true});
window.addEventListener('resize', updateProductMenuFade);
updateProductMenuFade();

const normalizeGridRatings = () => {
  document.querySelectorAll('.card-stars,.im-home .product-rating').forEach(rating => {
    const count = rating.querySelector('.yotpo-sr-bottom-line-text--right-panel');
    const match = count?.textContent.trim().match(/^\(?([\d,]+)/);
    if (match && count.textContent.trim() !== `(${match[1]})`) count.textContent = `(${match[1]})`;
    if (count && count.style.fontWeight !== '400') count.style.fontWeight = '400';
    const clearInline = (selector, properties) => {
      rating.querySelectorAll(selector).forEach(element => {
        properties.forEach(property => {
          if (element.style.getPropertyValue(property)) element.style.removeProperty(property);
        });
      });
    };
    clearInline('.yotpo-sr-bottom-line-summary', ['align-items']);
    clearInline('.yotpo-sr-bottom-line-score,.yotpo-sr-bottom-line-text--right-panel', ['font-size', 'line-height', 'padding-top', 'margin-bottom', 'margin-inline']);
    clearInline('span:has(>svg.star-container)', ['height']);
    clearInline('svg.star-container', ['margin-inline-end']);
    clearInline('.yotpo-sr-vertical-border', ['display']);
  });
};
new MutationObserver(records => {
  const addedRatings = records.some(record => Array.from(record.addedNodes).some(node =>
    node.nodeType === 1 && (node.matches('.card-stars,.im-home .product-rating') || node.querySelector('.card-stars,.im-home .product-rating'))
  ));
  if (addedRatings) window.yotpoWidgetsContainer?.initWidgets?.();
  normalizeGridRatings();
}).observe(document.body, {childList:true, subtree:true});
normalizeGridRatings();
